/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsUp = createReactComponent("arrows-up", "IconArrowsUp", [
  ["path", { d: "M17 3l0 18", key: "svg-0" }],
  ["path", { d: "M4 6l3 -3l3 3", key: "svg-1" }],
  ["path", { d: "M20 6l-3 -3l-3 3", key: "svg-2" }],
  ["path", { d: "M7 3l0 18", key: "svg-3" }]
]);

export { IconArrowsUp as default };
//# sourceMappingURL=IconArrowsUp.js.map
